// The translated strings themselves; the lookup lives in chromeCopy.ts.
import type { NoticeChromeCopy } from "../types";

export const NOTICE_CHROME_EN: NoticeChromeCopy = {
  yes: "Yes",
  no: "No",
  mixed: "Partly",
  savedAnswer: "Saved answer: {answer}",
  confirmAcceptAllTitle: "Accept every purpose?",
  confirmAcceptAllDetail:
    "This agrees to all purposes on this notice, including any you left unselected.",
  confirmAcceptSelectedTitle: "Confirm your selections?",
  confirmAcceptSelectedDetail:
    "Only the purposes you selected are recorded as agreed. The rest are recorded as not agreed.",
  confirmDeclineTitle: "Decline this notice?",
  confirmDeclineDetail:
    "Nothing is recorded as agreed, including any purposes you selected.",
  otpTitle: "Enter the verification code",
  otpDescription:
    "Ask the customer to read out the code they were sent. Your selections are locked until it is confirmed.",
  otpSubmit: "Confirm code",
  otpVerifying: "Verifying...",
  otpFailed: "Could not verify that code.",
  productPoliciesLabel: "Privacy policies:",
  hintNothingChosen: "Select at least one purpose to confirm.",
  hintNothingEngaged:
    "Select or change a purpose for the product you are consenting to.",
  hintRequiredOutstanding: "Accept the required purposes to confirm.",
};

export const TRANSLATIONS: Record<string, NoticeChromeCopy> = {
  en: NOTICE_CHROME_EN,
  hi: {
    yes: "हाँ",
    no: "नहीं",
    mixed: "आंशिक",
    savedAnswer: "सहेजा गया उत्तर: {answer}",
    confirmAcceptAllTitle: "सभी उद्देश्य स्वीकार करें?",
    confirmAcceptAllDetail:
      "इससे इस सूचना के सभी उद्देश्यों पर सहमति दी जाती है, उन्हें भी जिन्हें आपने नहीं चुना।",
    confirmAcceptSelectedTitle: "अपने चयन की पुष्टि करें?",
    confirmAcceptSelectedDetail:
      "केवल आपके चुने हुए उद्देश्य सहमत के रूप में दर्ज होंगे। शेष असहमत के रूप में दर्ज होंगे।",
    confirmDeclineTitle: "इस सूचना को अस्वीकार करें?",
    confirmDeclineDetail:
      "कुछ भी सहमत के रूप में दर्ज नहीं होगा, आपके चुने हुए उद्देश्य भी नहीं।",
    otpTitle: "सत्यापन कोड दर्ज करें",
    otpDescription:
      "ग्राहक से भेजा गया कोड पढ़ने के लिए कहें। पुष्टि होने तक आपके चयन लॉक रहेंगे।",
    otpSubmit: "कोड की पुष्टि करें",
    otpVerifying: "सत्यापित किया जा रहा है...",
    otpFailed: "यह कोड सत्यापित नहीं हो सका।",
    productPoliciesLabel: "गोपनीयता नीतियाँ:",
    hintNothingChosen: "पुष्टि के लिए कम से कम एक उद्देश्य चुनें।",
    hintNothingEngaged:
      "जिस उत्पाद के लिए आप सहमति दे रहे हैं, उसका कोई उद्देश्य चुनें या बदलें।",
    hintRequiredOutstanding: "पुष्टि के लिए आवश्यक उद्देश्य स्वीकार करें।",
  },
  bn: {
    yes: "হ্যাঁ",
    no: "না",
    mixed: "আংশিক",
    savedAnswer: "সংরক্ষিত উত্তর: {answer}",
    confirmAcceptAllTitle: "সব উদ্দেশ্য গ্রহণ করবেন?",
    confirmAcceptAllDetail:
      "এতে এই বিজ্ঞপ্তির সব উদ্দেশ্যে সম্মতি দেওয়া হয়, আপনি যেগুলি নির্বাচন করেননি সেগুলি সহ।",
    confirmAcceptSelectedTitle: "আপনার নির্বাচন নিশ্চিত করবেন?",
    confirmAcceptSelectedDetail:
      "শুধু আপনার নির্বাচিত উদ্দেশ্যগুলি সম্মত হিসাবে নথিভুক্ত হবে। বাকিগুলি অসম্মত হিসাবে নথিভুক্ত হবে।",
    confirmDeclineTitle: "এই বিজ্ঞপ্তি প্রত্যাখ্যান করবেন?",
    confirmDeclineDetail:
      "কিছুই সম্মত হিসাবে নথিভুক্ত হবে না, আপনার নির্বাচিত উদ্দেশ্যগুলিও নয়।",
    otpTitle: "যাচাইকরণ কোড লিখুন",
    otpDescription:
      "গ্রাহককে পাঠানো কোডটি পড়তে বলুন। নিশ্চিত না হওয়া পর্যন্ত আপনার নির্বাচন লক থাকবে।",
    otpSubmit: "কোড নিশ্চিত করুন",
    otpVerifying: "যাচাই করা হচ্ছে...",
    otpFailed: "এই কোডটি যাচাই করা যায়নি।",
    productPoliciesLabel: "গোপনীয়তা নীতি:",
    hintNothingChosen: "নিশ্চিত করতে অন্তত একটি উদ্দেশ্য নির্বাচন করুন।",
    hintNothingEngaged:
      "আপনি যে পণ্যে সম্মতি দিচ্ছেন তার একটি উদ্দেশ্য নির্বাচন করুন বা পরিবর্তন করুন।",
    hintRequiredOutstanding: "নিশ্চিত করতে আবশ্যক উদ্দেশ্যগুলি গ্রহণ করুন।",
  },
  mr: {
    yes: "होय",
    no: "नाही",
    mixed: "अंशतः",
    savedAnswer: "जतन केलेले उत्तर: {answer}",
    confirmAcceptAllTitle: "सर्व उद्दिष्टे स्वीकारायची?",
    confirmAcceptAllDetail:
      "यामुळे या सूचनेतील सर्व उद्दिष्टांना संमती मिळते, तुम्ही न निवडलेल्यांसह.",
    confirmAcceptSelectedTitle: "तुमच्या निवडींची पुष्टी करायची?",
    confirmAcceptSelectedDetail:
      "फक्त तुम्ही निवडलेली उद्दिष्टे संमत म्हणून नोंदवली जातील. उर्वरित असंमत म्हणून नोंदवली जातील.",
    confirmDeclineTitle: "ही सूचना नाकारायची?",
    confirmDeclineDetail:
      "काहीही संमत म्हणून नोंदवले जाणार नाही, तुम्ही निवडलेली उद्दिष्टेही नाहीत.",
    otpTitle: "पडताळणी कोड प्रविष्ट करा",
    otpDescription:
      "ग्राहकाला पाठवलेला कोड वाचायला सांगा. पुष्टी होईपर्यंत तुमच्या निवडी लॉक राहतील.",
    otpSubmit: "कोडची पुष्टी करा",
    otpVerifying: "पडताळणी होत आहे...",
    otpFailed: "हा कोड पडताळता आला नाही.",
    productPoliciesLabel: "गोपनीयता धोरणे:",
    hintNothingChosen: "पुष्टी करण्यासाठी किमान एक उद्दिष्ट निवडा.",
    hintNothingEngaged:
      "तुम्ही ज्या उत्पादनाला संमती देत आहात त्याचे उद्दिष्ट निवडा किंवा बदला.",
    hintRequiredOutstanding: "पुष्टी करण्यासाठी आवश्यक उद्दिष्टे स्वीकारा.",
  },
  ta: {
    yes: "ஆம்",
    no: "இல்லை",
    mixed: "பகுதி",
    savedAnswer: "சேமித்த பதில்: {answer}",
    confirmAcceptAllTitle: "அனைத்து நோக்கங்களையும் ஏற்கவா?",
    confirmAcceptAllDetail:
      "இது இந்த அறிவிப்பின் அனைத்து நோக்கங்களுக்கும் ஒப்புதல் அளிக்கிறது, நீங்கள் தேர்ந்தெடுக்காதவை உட்பட.",
    confirmAcceptSelectedTitle: "உங்கள் தேர்வுகளை உறுதிப்படுத்தவா?",
    confirmAcceptSelectedDetail:
      "நீங்கள் தேர்ந்தெடுத்த நோக்கங்கள் மட்டுமே ஒப்புக்கொண்டதாகப் பதிவு செய்யப்படும். மற்றவை ஒப்புக்கொள்ளாததாகப் பதிவு செய்யப்படும்.",
    confirmDeclineTitle: "இந்த அறிவிப்பை நிராகரிக்கவா?",
    confirmDeclineDetail:
      "எதுவும் ஒப்புக்கொண்டதாகப் பதிவு செய்யப்படாது, நீங்கள் தேர்ந்தெடுத்த நோக்கங்களும் அல்ல.",
    otpTitle: "சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்",
    otpDescription:
      "அனுப்பப்பட்ட குறியீட்டை வாசிக்கும்படி வாடிக்கையாளரிடம் கேளுங்கள். உறுதிப்படுத்தும் வரை உங்கள் தேர்வுகள் பூட்டப்பட்டிருக்கும்.",
    otpSubmit: "குறியீட்டை உறுதிப்படுத்து",
    otpVerifying: "சரிபார்க்கப்படுகிறது...",
    otpFailed: "அந்தக் குறியீட்டைச் சரிபார்க்க முடியவில்லை.",
    productPoliciesLabel: "தனியுரிமைக் கொள்கைகள்:",
    hintNothingChosen:
      "உறுதிப்படுத்த குறைந்தது ஒரு நோக்கத்தைத் தேர்ந்தெடுக்கவும்.",
    hintNothingEngaged:
      "நீங்கள் ஒப்புதல் அளிக்கும் தயாரிப்பின் நோக்கத்தைத் தேர்ந்தெடுக்கவும் அல்லது மாற்றவும்.",
    hintRequiredOutstanding: "உறுதிப்படுத்த தேவையான நோக்கங்களை ஏற்கவும்.",
  },
  te: {
    yes: "అవును",
    no: "కాదు",
    mixed: "పాక్షిక",
    savedAnswer: "సేవ్ చేసిన సమాధానం: {answer}",
    confirmAcceptAllTitle: "అన్ని ప్రయోజనాలను అంగీకరించాలా?",
    confirmAcceptAllDetail:
      "ఇది ఈ నోటీసులోని అన్ని ప్రయోజనాలకు అంగీకరిస్తుంది, మీరు ఎంచుకోనివి సహా.",
    confirmAcceptSelectedTitle: "మీ ఎంపికలను నిర్ధారించాలా?",
    confirmAcceptSelectedDetail:
      "మీరు ఎంచుకున్న ప్రయోజనాలు మాత్రమే అంగీకరించినట్లు నమోదవుతాయి. మిగిలినవి అంగీకరించనట్లు నమోదవుతాయి.",
    confirmDeclineTitle: "ఈ నోటీసును తిరస్కరించాలా?",
    confirmDeclineDetail:
      "ఏదీ అంగీకరించినట్లు నమోదు కాదు, మీరు ఎంచుకున్న ప్రయోజనాలు కూడా కాదు.",
    otpTitle: "ధృవీకరణ కోడ్‌ను నమోదు చేయండి",
    otpDescription:
      "పంపిన కోడ్‌ను చదవమని కస్టమర్‌ను అడగండి. నిర్ధారణ అయ్యే వరకు మీ ఎంపికలు లాక్ అవుతాయి.",
    otpSubmit: "కోడ్‌ను నిర్ధారించండి",
    otpVerifying: "ధృవీకరిస్తోంది...",
    otpFailed: "ఆ కోడ్‌ను ధృవీకరించలేకపోయాము.",
    productPoliciesLabel: "గోప్యతా విధానాలు:",
    hintNothingChosen: "నిర్ధారించడానికి కనీసం ఒక ప్రయోజనాన్ని ఎంచుకోండి.",
    hintNothingEngaged:
      "మీరు సమ్మతి ఇస్తున్న ఉత్పత్తికి ఒక ప్రయోజనాన్ని ఎంచుకోండి లేదా మార్చండి.",
    hintRequiredOutstanding:
      "నిర్ధారించడానికి అవసరమైన ప్రయోజనాలను అంగీకరించండి.",
  },
  gu: {
    yes: "હા",
    no: "ના",
    mixed: "આંશિક",
    savedAnswer: "સાચવેલ જવાબ: {answer}",
    confirmAcceptAllTitle: "બધા હેતુઓ સ્વીકારવા?",
    confirmAcceptAllDetail:
      "આથી આ સૂચનાના બધા હેતુઓને સંમતિ મળે છે, તમે પસંદ ન કરેલા સહિત.",
    confirmAcceptSelectedTitle: "તમારી પસંદગીઓની પુષ્ટિ કરવી?",
    confirmAcceptSelectedDetail:
      "ફક્ત તમે પસંદ કરેલા હેતુઓ સંમત તરીકે નોંધાશે. બાકીના અસંમત તરીકે નોંધાશે.",
    confirmDeclineTitle: "આ સૂચના નકારવી?",
    confirmDeclineDetail:
      "કંઈપણ સંમત તરીકે નોંધાશે નહીં, તમે પસંદ કરેલા હેતુઓ પણ નહીં.",
    otpTitle: "ચકાસણી કોડ દાખલ કરો",
    otpDescription:
      "ગ્રાહકને મોકલેલો કોડ વાંચવા કહો. પુષ્ટિ થાય ત્યાં સુધી તમારી પસંદગીઓ લૉક રહેશે.",
    otpSubmit: "કોડની પુષ્ટિ કરો",
    otpVerifying: "ચકાસાઈ રહ્યું છે...",
    otpFailed: "તે કોડ ચકાસી શકાયો નથી.",
    productPoliciesLabel: "ગોપનીયતા નીતિઓ:",
    hintNothingChosen: "પુષ્ટિ કરવા ઓછામાં ઓછો એક હેતુ પસંદ કરો.",
    hintNothingEngaged:
      "તમે જે ઉત્પાદનને સંમતિ આપી રહ્યા છો તેનો હેતુ પસંદ કરો અથવા બદલો.",
    hintRequiredOutstanding: "પુષ્ટિ કરવા જરૂરી હેતુઓ સ્વીકારો.",
  },
  kn: {
    yes: "ಹೌದು",
    no: "ಇಲ್ಲ",
    mixed: "ಭಾಗಶಃ",
    savedAnswer: "ಉಳಿಸಿದ ಉತ್ತರ: {answer}",
    confirmAcceptAllTitle: "ಎಲ್ಲಾ ಉದ್ದೇಶಗಳನ್ನು ಸ್ವೀಕರಿಸುವುದೇ?",
    confirmAcceptAllDetail:
      "ಇದು ಈ ಸೂಚನೆಯ ಎಲ್ಲಾ ಉದ್ದೇಶಗಳಿಗೆ ಸಮ್ಮತಿಸುತ್ತದೆ, ನೀವು ಆಯ್ಕೆ ಮಾಡದವುಗಳೂ ಸೇರಿ.",
    confirmAcceptSelectedTitle: "ನಿಮ್ಮ ಆಯ್ಕೆಗಳನ್ನು ಖಚಿತಪಡಿಸುವುದೇ?",
    confirmAcceptSelectedDetail:
      "ನೀವು ಆಯ್ಕೆ ಮಾಡಿದ ಉದ್ದೇಶಗಳು ಮಾತ್ರ ಸಮ್ಮತಿಸಿದಂತೆ ದಾಖಲಾಗುತ್ತವೆ. ಉಳಿದವು ಸಮ್ಮತಿಸದಂತೆ ದಾಖಲಾಗುತ್ತವೆ.",
    confirmDeclineTitle: "ಈ ಸೂಚನೆಯನ್ನು ನಿರಾಕರಿಸುವುದೇ?",
    confirmDeclineDetail:
      "ಯಾವುದೂ ಸಮ್ಮತಿಸಿದಂತೆ ದಾಖಲಾಗುವುದಿಲ್ಲ, ನೀವು ಆಯ್ಕೆ ಮಾಡಿದ ಉದ್ದೇಶಗಳೂ ಅಲ್ಲ.",
    otpTitle: "ಪರಿಶೀಲನಾ ಕೋಡ್ ನಮೂದಿಸಿ",
    otpDescription:
      "ಕಳುಹಿಸಿದ ಕೋಡ್ ಅನ್ನು ಓದಲು ಗ್ರಾಹಕರನ್ನು ಕೇಳಿ. ಖಚಿತವಾಗುವವರೆಗೆ ನಿಮ್ಮ ಆಯ್ಕೆಗಳು ಲಾಕ್ ಆಗಿರುತ್ತವೆ.",
    otpSubmit: "ಕೋಡ್ ಖಚಿತಪಡಿಸಿ",
    otpVerifying: "ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...",
    otpFailed: "ಆ ಕೋಡ್ ಅನ್ನು ಪರಿಶೀಲಿಸಲಾಗಲಿಲ್ಲ.",
    productPoliciesLabel: "ಗೌಪ್ಯತಾ ನೀತಿಗಳು:",
    hintNothingChosen: "ಖಚಿತಪಡಿಸಲು ಕನಿಷ್ಠ ಒಂದು ಉದ್ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    hintNothingEngaged:
      "ನೀವು ಸಮ್ಮತಿ ನೀಡುತ್ತಿರುವ ಉತ್ಪನ್ನದ ಉದ್ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ ಅಥವಾ ಬದಲಾಯಿಸಿ.",
    hintRequiredOutstanding: "ಖಚಿತಪಡಿಸಲು ಅಗತ್ಯವಿರುವ ಉದ್ದೇಶಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",
  },
  ml: {
    yes: "അതെ",
    no: "അല്ല",
    mixed: "ഭാഗികം",
    savedAnswer: "സംരക്ഷിച്ച ഉത്തരം: {answer}",
    confirmAcceptAllTitle: "എല്ലാ ഉദ്ദേശ്യങ്ങളും സ്വീകരിക്കണോ?",
    confirmAcceptAllDetail:
      "ഇത് ഈ അറിയിപ്പിലെ എല്ലാ ഉദ്ദേശ്യങ്ങൾക്കും സമ്മതം നൽകുന്നു, നിങ്ങൾ തിരഞ്ഞെടുക്കാത്തവ ഉൾപ്പെടെ.",
    confirmAcceptSelectedTitle: "നിങ്ങളുടെ തിരഞ്ഞെടുപ്പുകൾ സ്ഥിരീകരിക്കണോ?",
    confirmAcceptSelectedDetail:
      "നിങ്ങൾ തിരഞ്ഞെടുത്ത ഉദ്ദേശ്യങ്ങൾ മാത്രം സമ്മതിച്ചതായി രേഖപ്പെടുത്തും. ബാക്കിയുള്ളവ സമ്മതിക്കാത്തതായി രേഖപ്പെടുത്തും.",
    confirmDeclineTitle: "ഈ അറിയിപ്പ് നിരസിക്കണോ?",
    confirmDeclineDetail:
      "ഒന്നും സമ്മതിച്ചതായി രേഖപ്പെടുത്തില്ല, നിങ്ങൾ തിരഞ്ഞെടുത്ത ഉദ്ദേശ്യങ്ങളും ഇല്ല.",
    otpTitle: "പരിശോധനാ കോഡ് നൽകുക",
    otpDescription:
      "അയച്ച കോഡ് വായിക്കാൻ ഉപഭോക്താവിനോട് ആവശ്യപ്പെടുക. സ്ഥിരീകരിക്കുന്നതുവരെ നിങ്ങളുടെ തിരഞ്ഞെടുപ്പുകൾ ലോക്ക് ചെയ്യപ്പെടും.",
    otpSubmit: "കോഡ് സ്ഥിരീകരിക്കുക",
    otpVerifying: "പരിശോധിക്കുന്നു...",
    otpFailed: "ആ കോഡ് പരിശോധിക്കാനായില്ല.",
    productPoliciesLabel: "സ്വകാര്യതാ നയങ്ങൾ:",
    hintNothingChosen:
      "സ്ഥിരീകരിക്കാൻ കുറഞ്ഞത് ഒരു ഉദ്ദേശ്യമെങ്കിലും തിരഞ്ഞെടുക്കുക.",
    hintNothingEngaged:
      "നിങ്ങൾ സമ്മതം നൽകുന്ന ഉൽപ്പന്നത്തിന്റെ ഉദ്ദേശ്യം തിരഞ്ഞെടുക്കുകയോ മാറ്റുകയോ ചെയ്യുക.",
    hintRequiredOutstanding:
      "സ്ഥിരീകരിക്കാൻ ആവശ്യമായ ഉദ്ദേശ്യങ്ങൾ സ്വീകരിക്കുക.",
  },
  pa: {
    yes: "ਹਾਂ",
    no: "ਨਹੀਂ",
    mixed: "ਅੰਸ਼ਕ",
    savedAnswer: "ਸੰਭਾਲਿਆ ਜਵਾਬ: {answer}",
    confirmAcceptAllTitle: "ਸਾਰੇ ਮੰਤਵ ਸਵੀਕਾਰ ਕਰਨੇ ਹਨ?",
    confirmAcceptAllDetail:
      "ਇਸ ਨਾਲ ਇਸ ਸੂਚਨਾ ਦੇ ਸਾਰੇ ਮੰਤਵਾਂ ਲਈ ਸਹਿਮਤੀ ਦਿੱਤੀ ਜਾਂਦੀ ਹੈ, ਉਹ ਵੀ ਜੋ ਤੁਸੀਂ ਨਹੀਂ ਚੁਣੇ।",
    confirmAcceptSelectedTitle: "ਆਪਣੀਆਂ ਚੋਣਾਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨੀ ਹੈ?",
    confirmAcceptSelectedDetail:
      "ਸਿਰਫ਼ ਤੁਹਾਡੇ ਚੁਣੇ ਮੰਤਵ ਸਹਿਮਤ ਵਜੋਂ ਦਰਜ ਹੋਣਗੇ। ਬਾਕੀ ਅਸਹਿਮਤ ਵਜੋਂ ਦਰਜ ਹੋਣਗੇ।",
    confirmDeclineTitle: "ਇਹ ਸੂਚਨਾ ਰੱਦ ਕਰਨੀ ਹੈ?",
    confirmDeclineDetail:
      "ਕੁਝ ਵੀ ਸਹਿਮਤ ਵਜੋਂ ਦਰਜ ਨਹੀਂ ਹੋਵੇਗਾ, ਤੁਹਾਡੇ ਚੁਣੇ ਮੰਤਵ ਵੀ ਨਹੀਂ।",
    otpTitle: "ਤਸਦੀਕ ਕੋਡ ਦਾਖਲ ਕਰੋ",
    otpDescription:
      "ਗਾਹਕ ਨੂੰ ਭੇਜਿਆ ਕੋਡ ਪੜ੍ਹਨ ਲਈ ਕਹੋ। ਪੁਸ਼ਟੀ ਹੋਣ ਤੱਕ ਤੁਹਾਡੀਆਂ ਚੋਣਾਂ ਲਾਕ ਰਹਿਣਗੀਆਂ।",
    otpSubmit: "ਕੋਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    otpVerifying: "ਤਸਦੀਕ ਹੋ ਰਿਹਾ ਹੈ...",
    otpFailed: "ਉਹ ਕੋਡ ਤਸਦੀਕ ਨਹੀਂ ਹੋ ਸਕਿਆ।",
    productPoliciesLabel: "ਪਰਦੇਦਾਰੀ ਨੀਤੀਆਂ:",
    hintNothingChosen: "ਪੁਸ਼ਟੀ ਲਈ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਮੰਤਵ ਚੁਣੋ।",
    hintNothingEngaged:
      "ਜਿਸ ਉਤਪਾਦ ਲਈ ਤੁਸੀਂ ਸਹਿਮਤੀ ਦੇ ਰਹੇ ਹੋ, ਉਸ ਦਾ ਮੰਤਵ ਚੁਣੋ ਜਾਂ ਬਦਲੋ।",
    hintRequiredOutstanding: "ਪੁਸ਼ਟੀ ਲਈ ਲੋੜੀਂਦੇ ਮੰਤਵ ਸਵੀਕਾਰ ਕਰੋ।",
  },
  or: {
    yes: "ହଁ",
    no: "ନା",
    mixed: "ଆଂଶିକ",
    savedAnswer: "ସଞ୍ଚିତ ଉତ୍ତର: {answer}",
    confirmAcceptAllTitle: "ସମସ୍ତ ଉଦ୍ଦେଶ୍ୟ ଗ୍ରହଣ କରିବେ?",
    confirmAcceptAllDetail:
      "ଏହା ଏହି ସୂଚନାର ସମସ୍ତ ଉଦ୍ଦେଶ୍ୟକୁ ସମ୍ମତି ଦିଏ, ଆପଣ ଚୟନ ନକରିଥିବା ଗୁଡ଼ିକ ସହିତ।",
    confirmAcceptSelectedTitle: "ଆପଣଙ୍କ ଚୟନ ନିଶ୍ଚିତ କରିବେ?",
    confirmAcceptSelectedDetail:
      "କେବଳ ଆପଣ ଚୟନ କରିଥିବା ଉଦ୍ଦେଶ୍ୟ ସମ୍ମତ ଭାବେ ଲିପିବଦ୍ଧ ହେବ। ବାକିଗୁଡ଼ିକ ଅସମ୍ମତ ଭାବେ ଲିପିବଦ୍ଧ ହେବ।",
    confirmDeclineTitle: "ଏହି ସୂଚନା ପ୍ରତ୍ୟାଖ୍ୟାନ କରିବେ?",
    confirmDeclineDetail:
      "କିଛି ବି ସମ୍ମତ ଭାବେ ଲିପିବଦ୍ଧ ହେବ ନାହିଁ, ଆପଣ ଚୟନ କରିଥିବା ଉଦ୍ଦେଶ୍ୟ ମଧ୍ୟ ନୁହେଁ।",
    otpTitle: "ଯାଞ୍ଚ କୋଡ୍ ପ୍ରବେଶ କରନ୍ତୁ",
    otpDescription:
      "ପଠାଯାଇଥିବା କୋଡ୍ ପଢ଼ିବାକୁ ଗ୍ରାହକଙ୍କୁ କୁହନ୍ତୁ। ନିଶ୍ଚିତ ନହେବା ପର୍ଯ୍ୟନ୍ତ ଆପଣଙ୍କ ଚୟନ ଲକ୍ ରହିବ।",
    otpSubmit: "କୋଡ୍ ନିଶ୍ଚିତ କରନ୍ତୁ",
    otpVerifying: "ଯାଞ୍ଚ କରାଯାଉଛି...",
    otpFailed: "ସେହି କୋଡ୍ ଯାଞ୍ଚ କରାଯାଇପାରିଲା ନାହିଁ।",
    productPoliciesLabel: "ଗୋପନୀୟତା ନୀତି:",
    hintNothingChosen: "ନିଶ୍ଚିତ କରିବାକୁ ଅତି କମରେ ଗୋଟିଏ ଉଦ୍ଦେଶ୍ୟ ଚୟନ କରନ୍ତୁ।",
    hintNothingEngaged:
      "ଆପଣ ସମ୍ମତି ଦେଉଥିବା ଉତ୍ପାଦର ଉଦ୍ଦେଶ୍ୟ ଚୟନ କରନ୍ତୁ କିମ୍ବା ବଦଳାନ୍ତୁ।",
    hintRequiredOutstanding: "ନିଶ୍ଚିତ କରିବାକୁ ଆବଶ୍ୟକ ଉଦ୍ଦେଶ୍ୟ ଗ୍ରହଣ କରନ୍ତୁ।",
  },
  as: {
    yes: "হয়",
    no: "নহয়",
    mixed: "আংশিক",
    savedAnswer: "সংৰক্ষিত উত্তৰ: {answer}",
    confirmAcceptAllTitle: "সকলো উদ্দেশ্য গ্ৰহণ কৰিবনে?",
    confirmAcceptAllDetail:
      "ই এই জাননীৰ সকলো উদ্দেশ্যত সন্মতি দিয়ে, আপুনি নিৰ্বাচন নকৰাবোৰো ধৰি।",
    confirmAcceptSelectedTitle: "আপোনাৰ নিৰ্বাচন নিশ্চিত কৰিবনে?",
    confirmAcceptSelectedDetail:
      "কেৱল আপুনি নিৰ্বাচন কৰা উদ্দেশ্যবোৰ সন্মত হিচাপে লিপিবদ্ধ হ'ব। বাকীবোৰ অসন্মত হিচাপে লিপিবদ্ধ হ'ব।",
    confirmDeclineTitle: "এই জাননী প্ৰত্যাখ্যান কৰিবনে?",
    confirmDeclineDetail:
      "একোৱেই সন্মত হিচাপে লিপিবদ্ধ নহ'ব, আপুনি নিৰ্বাচন কৰা উদ্দেশ্যবোৰো নহয়।",
    otpTitle: "সত্যাপন ক'ড দিয়ক",
    otpDescription:
      "পঠোৱা ক'ডটো পঢ়িবলৈ গ্ৰাহকক কওক। নিশ্চিত নোহোৱালৈকে আপোনাৰ নিৰ্বাচন লক থাকিব।",
    otpSubmit: "ক'ড নিশ্চিত কৰক",
    otpVerifying: "সত্যাপন কৰা হৈছে...",
    otpFailed: "সেই ক'ডটো সত্যাপন কৰিব পৰা নগ'ল।",
    productPoliciesLabel: "গোপনীয়তা নীতিসমূহ:",
    hintNothingChosen: "নিশ্চিত কৰিবলৈ অন্ততঃ এটা উদ্দেশ্য নিৰ্বাচন কৰক।",
    hintNothingEngaged:
      "আপুনি সন্মতি দি থকা সামগ্ৰীৰ এটা উদ্দেশ্য নিৰ্বাচন কৰক বা সলনি কৰক।",
    hintRequiredOutstanding:
      "নিশ্চিত কৰিবলৈ প্ৰয়োজনীয় উদ্দেশ্যবোৰ গ্ৰহণ কৰক।",
  },
  ur: {
    yes: "ہاں",
    no: "نہیں",
    mixed: "جزوی",
    savedAnswer: "محفوظ جواب: {answer}",
    confirmAcceptAllTitle: "تمام مقاصد قبول کریں؟",
    confirmAcceptAllDetail:
      "اس سے اس نوٹس کے تمام مقاصد پر رضامندی دی جاتی ہے، ان سمیت جو آپ نے منتخب نہیں کیے۔",
    confirmAcceptSelectedTitle: "اپنے انتخاب کی تصدیق کریں؟",
    confirmAcceptSelectedDetail:
      "صرف آپ کے منتخب کردہ مقاصد رضامند کے طور پر درج ہوں گے۔ باقی غیر رضامند کے طور پر درج ہوں گے۔",
    confirmDeclineTitle: "اس نوٹس کو مسترد کریں؟",
    confirmDeclineDetail:
      "کچھ بھی رضامند کے طور پر درج نہیں ہوگا، آپ کے منتخب کردہ مقاصد بھی نہیں۔",
    otpTitle: "تصدیقی کوڈ درج کریں",
    otpDescription:
      "گاہک سے بھیجا گیا کوڈ پڑھنے کو کہیں۔ تصدیق ہونے تک آپ کے انتخاب مقفل رہیں گے۔",
    otpSubmit: "کوڈ کی تصدیق کریں",
    otpVerifying: "تصدیق ہو رہی ہے...",
    otpFailed: "اس کوڈ کی تصدیق نہیں ہو سکی۔",
    productPoliciesLabel: "پرائیویسی پالیسیاں:",
    hintNothingChosen: "تصدیق کے لیے کم از کم ایک مقصد منتخب کریں۔",
    hintNothingEngaged:
      "جس پروڈکٹ کے لیے آپ رضامندی دے رہے ہیں، اس کا مقصد منتخب کریں یا تبدیل کریں۔",
    hintRequiredOutstanding: "تصدیق کے لیے مطلوبہ مقاصد قبول کریں۔",
  },
  ne: {
    yes: "हो",
    no: "होइन",
    mixed: "आंशिक",
    savedAnswer: "सुरक्षित उत्तर: {answer}",
    confirmAcceptAllTitle: "सबै उद्देश्य स्वीकार गर्ने?",
    confirmAcceptAllDetail:
      "यसले यस सूचनाका सबै उद्देश्यमा सहमति दिन्छ, तपाईंले नछानेका पनि।",
    confirmAcceptSelectedTitle: "आफ्ना छनोट पुष्टि गर्ने?",
    confirmAcceptSelectedDetail:
      "तपाईंले छानेका उद्देश्य मात्र सहमत रूपमा दर्ता हुनेछन्। बाँकी असहमत रूपमा दर्ता हुनेछन्।",
    confirmDeclineTitle: "यो सूचना अस्वीकार गर्ने?",
    confirmDeclineDetail:
      "केही पनि सहमत रूपमा दर्ता हुनेछैन, तपाईंले छानेका उद्देश्य पनि होइन।",
    otpTitle: "प्रमाणीकरण कोड प्रविष्ट गर्नुहोस्",
    otpDescription:
      "पठाइएको कोड पढ्न ग्राहकलाई भन्नुहोस्। पुष्टि नहुँदासम्म तपाईंका छनोट लक रहनेछन्।",
    otpSubmit: "कोड पुष्टि गर्नुहोस्",
    otpVerifying: "प्रमाणीकरण गर्दै...",
    otpFailed: "त्यो कोड प्रमाणित गर्न सकिएन।",
    productPoliciesLabel: "गोपनीयता नीतिहरू:",
    hintNothingChosen: "पुष्टि गर्न कम्तीमा एउटा उद्देश्य छान्नुहोस्।",
    hintNothingEngaged:
      "तपाईंले सहमति दिइरहनुभएको उत्पादनको उद्देश्य छान्नुहोस् वा परिवर्तन गर्नुहोस्।",
    hintRequiredOutstanding: "पुष्टि गर्न आवश्यक उद्देश्य स्वीकार गर्नुहोस्।",
  },
  sa: {
    yes: "आम्",
    no: "न",
    mixed: "आंशिकम्",
    savedAnswer: "रक्षितम् उत्तरम्: {answer}",
    confirmAcceptAllTitle: "सर्वाणि प्रयोजनानि स्वीकुर्वन्तु?",
    confirmAcceptAllDetail:
      "अनेन अस्याः सूचनायाः सर्वेषु प्रयोजनेषु सम्मतिः दीयते, यानि भवता न चितानि तान्यपि।",
    confirmAcceptSelectedTitle: "स्वचयनानि निश्चिनोतु?",
    confirmAcceptSelectedDetail:
      "केवलं भवता चितानि प्रयोजनानि सम्मतानि इति लिख्यन्ते। शेषाणि असम्मतानि इति लिख्यन्ते।",
    confirmDeclineTitle: "एतां सूचनां निराकरोतु?",
    confirmDeclineDetail:
      "किमपि सम्मतम् इति न लिख्यते, भवता चितानि प्रयोजनानि अपि न।",
    otpTitle: "सत्यापनसङ्केतं प्रविशतु",
    otpDescription:
      "प्रेषितं सङ्केतं पठितुं ग्राहकं वदतु। निश्चयपर्यन्तं भवतः चयनानि निरुद्धानि भवन्ति।",
    otpSubmit: "सङ्केतं निश्चिनोतु",
    otpVerifying: "सत्यापनं क्रियते...",
    otpFailed: "सः सङ्केतः सत्यापयितुं न शक्यते।",
    productPoliciesLabel: "गोपनीयतानीतयः:",
    hintNothingChosen: "निश्चेतुं न्यूनातिन्यूनम् एकं प्रयोजनं चिनोतु।",
    hintNothingEngaged:
      "यस्मै उत्पादाय भवान् सम्मतिं ददाति तस्य प्रयोजनं चिनोतु परिवर्तयतु वा।",
    hintRequiredOutstanding: "निश्चेतुम् आवश्यकानि प्रयोजनानि स्वीकुर्वन्तु।",
  },
  mai: {
    yes: "हँ",
    no: "नहि",
    mixed: "आंशिक",
    savedAnswer: "सहेजल उत्तर: {answer}",
    confirmAcceptAllTitle: "सभ उद्देश्य स्वीकार करी?",
    confirmAcceptAllDetail:
      "एहिसँ एहि सूचनाक सभ उद्देश्य पर सहमति देल जाइत अछि, जे अहाँ नहि चुनलहुँ ताहि सहित।",
    confirmAcceptSelectedTitle: "अपन चयनक पुष्टि करी?",
    confirmAcceptSelectedDetail:
      "मात्र अहाँक चुनल उद्देश्य सहमत रूपमे दर्ज होएत। शेष असहमत रूपमे दर्ज होएत।",
    confirmDeclineTitle: "एहि सूचनाकेँ अस्वीकार करी?",
    confirmDeclineDetail:
      "किछु सेहो सहमत रूपमे दर्ज नहि होएत, अहाँक चुनल उद्देश्य सेहो नहि।",
    otpTitle: "सत्यापन कोड दर्ज करू",
    otpDescription:
      "ग्राहकसँ पठाओल कोड पढ़बाक लेल कहू। पुष्टि होएब धरि अहाँक चयन लॉक रहत।",
    otpSubmit: "कोडक पुष्टि करू",
    otpVerifying: "सत्यापित कएल जा रहल अछि...",
    otpFailed: "ई कोड सत्यापित नहि भ सकल।",
    productPoliciesLabel: "गोपनीयता नीति:",
    hintNothingChosen: "पुष्टिक लेल कम सँ कम एकटा उद्देश्य चुनू।",
    hintNothingEngaged:
      "जाहि उत्पादक लेल अहाँ सहमति द रहल छी, ओकर उद्देश्य चुनू वा बदलू।",
    hintRequiredOutstanding: "पुष्टिक लेल आवश्यक उद्देश्य स्वीकार करू।",
  },
  gom: {
    yes: "हंय",
    no: "ना",
    mixed: "आंशिक",
    savedAnswer: "जतन केल्लें उत्तर: {answer}",
    confirmAcceptAllTitle: "सगळीं उद्दिश्टां स्वीकारचीं?",
    confirmAcceptAllDetail:
      "हाका लागून ह्या सुचोवणेच्या सगळ्या उद्दिश्टांक संमती मेळटा, तुवें निवडूंक नाशिल्लीं सयत.",
    confirmAcceptSelectedTitle: "तुज्या निवडीची खात्री करची?",
    confirmAcceptSelectedDetail:
      "फकत तुवें निवडिल्लीं उद्दिश्टां संमत म्हूण नोंद जातलीं. उरिल्लीं असंमत म्हूण नोंद जातलीं.",
    confirmDeclineTitle: "ही सुचोवणी न्हयकारची?",
    confirmDeclineDetail:
      "कांयच संमत म्हूण नोंद जावचें ना, तुवें निवडिल्लीं उद्दिश्टां लेगीत ना.",
    otpTitle: "पडताळणी कोड घालात",
    otpDescription:
      "धाडिल्लो कोड वाचपाक गिरायकाक सांगात. खात्री जायसर तुज्यो निवडी लॉक उरतल्यो.",
    otpSubmit: "कोडाची खात्री करात",
    otpVerifying: "पडताळणी जाता...",
    otpFailed: "तो कोड पडताळूंक जालो ना.",
    productPoliciesLabel: "गुपितपण धोरणां:",
    hintNothingChosen: "खात्री करपाक उणेंत उणें एक उद्दिश्ट निवडात.",
    hintNothingEngaged:
      "तुमी जाच्या उत्पादनाक संमती दितात ताचें उद्दिश्ट निवडात वा बदलात.",
    hintRequiredOutstanding: "खात्री करपाक जाय आशिल्लीं उद्दिश्टां स्वीकारात.",
  },
  doi: {
    yes: "हाँ",
    no: "नेईं",
    mixed: "अंशक",
    savedAnswer: "सहेजे दा जवाब: {answer}",
    confirmAcceptAllTitle: "सारे मकसद स्वीकार करने न?",
    confirmAcceptAllDetail:
      "इस्सै इस सूचना दे सारे मकसदें गी सहमति दित्ती जंदी ऐ, उ' बी जेह्ड़े तुसें नेईं चुने।",
    confirmAcceptSelectedTitle: "अपनी चोनें दी पुश्टी करनी ऐ?",
    confirmAcceptSelectedDetail:
      "सिर्फ तुंदे चुने दे मकसद सहमत दे तौर पर दर्ज होङन। बाकी असहमत दे तौर पर दर्ज होङन।",
    confirmDeclineTitle: "इस सूचना गी रद्द करना ऐ?",
    confirmDeclineDetail:
      "कुछ बी सहमत दे तौर पर दर्ज नेईं होग, तुंदे चुने दे मकसद बी नेईं।",
    otpTitle: "तस्दीक कोड दर्ज करो",
    otpDescription:
      "ग्राहक गी भेजे दा कोड पढ़ने आस्तै आखो। पुश्टी होने तकर तुंदियां चोनां लॉक रौंहगियां।",
    otpSubmit: "कोड दी पुश्टी करो",
    otpVerifying: "तस्दीक कीती जा करदी ऐ...",
    otpFailed: "उह् कोड तस्दीक नेईं होई सकेआ।",
    productPoliciesLabel: "निजता नीतियां:",
    hintNothingChosen: "पुश्टी आस्तै घट्टोघट्ट इक मकसद चुनो।",
    hintNothingEngaged:
      "जिस उत्पाद आस्तै तुस सहमति देआ करदे ओ, उंदा मकसद चुनो जां बदलो।",
    hintRequiredOutstanding: "पुश्टी आस्तै लोड़चदे मकसद स्वीकार करो।",
  },
  brx: {
    yes: "नंगौ",
    no: "नङा",
    mixed: "बाहागो",
    savedAnswer: "थिना दिनाय फिन: {answer}",
    confirmAcceptAllTitle: "गासैबो उद्देश्यखौ लानो नामा?",
    confirmAcceptAllDetail:
      "बेयाव बे खौरांनि गासैबो उद्देश्यखौ राजि होयो, नोंथाङा सायख'आखैमानिखौबो लाफानानै।",
    confirmAcceptSelectedTitle: "नोंथांनि सायखनायखौ थिक होनो नामा?",
    confirmAcceptSelectedDetail:
      "खालि नोंथाङा सायखनाय उद्देश्यखौल' राजि महरै लिरना दोनगोन। बागानथिङा राजि नङै महरै लिरना दोनगोन।",
    confirmDeclineTitle: "बे खौरांखौ नेवसिनो नामा?",
    confirmDeclineDetail:
      "जायखिजाया राजि महरै लिरना दोनाखै, नोंथाङा सायखनाय उद्देश्यबो नङा।",
    otpTitle: "थिक खालामनाय क'ड हाबहो",
    otpDescription:
      "दैथाय हरनाय क'डखौ फरायनो ग्राहकखौ बुं। थिक जायाब्लासिम नोंथांनि सायखनाया लक जादों।",
    otpSubmit: "क'डखौ थिक खालाम",
    otpVerifying: "थिक खालामगासिनो दं...",
    otpFailed: "बै क'डखौ थिक खालामनो हायाखै।",
    productPoliciesLabel: "गुबै नीति:",
    hintNothingChosen: "थिक खालामनो खमसिन मोनसे उद्देश्य सायख।",
    hintNothingEngaged:
      "नोंथाङा राजि होगासिनो दं बै प्र'डाक्टनि उद्देश्यखौ सायख एबा सोलाय।",
    hintRequiredOutstanding: "थिक खालामनो नांगौ उद्देश्यफोरखौ ला।",
  },
  "mni-Mtei": {
    yes: "ꯍꯣꯏ",
    no: "ꯅꯠꯇꯦ",
    mixed: "ꯁꯔꯨꯛ",
    savedAnswer: "ꯁꯦꯚ ꯇꯧꯔꯕ ꯄꯥꯎꯈꯨꯝ: {answer}",
    confirmAcceptAllTitle: "ꯄꯥꯟꯗꯝ ꯄꯨꯝꯅꯃꯛ ꯌꯥꯕꯔꯥ?",
    confirmAcceptAllDetail:
      "ꯃꯁꯤꯅ ꯈꯨꯗꯝ ꯑꯁꯤꯒꯤ ꯄꯥꯟꯗꯝ ꯄꯨꯝꯅꯃꯛꯇ ꯑꯌꯥꯕ ꯄꯤ, ꯅꯪꯅ ꯈꯅꯗꯕꯁꯤꯡꯁꯨ ꯌꯥꯎꯅ।",
    confirmAcceptSelectedTitle: "ꯅꯪꯒꯤ ꯈꯅꯕꯁꯤꯡ ꯆꯨꯝꯃꯤ ꯍꯥꯌꯕꯔꯥ?",
    confirmAcceptSelectedDetail:
      "ꯅꯪꯅ ꯈꯅꯕ ꯄꯥꯟꯗꯝꯁꯤꯡ ꯈꯛꯇꯅ ꯑꯌꯥꯕ ꯄꯤꯔꯕꯅꯤ ꯍꯥꯌꯅ ꯏꯔꯒꯅꯤ। ꯑꯇꯣꯞꯄꯁꯤꯡ ꯑꯌꯥꯕ ꯄꯤꯗꯕꯅꯤ ꯍꯥꯌꯅ ꯏꯔꯒꯅꯤ।",
    confirmDeclineTitle: "ꯈꯨꯗꯝ ꯑꯁꯤ ꯌꯥꯗꯕꯔꯥ?",
    confirmDeclineDetail:
      "ꯀꯔꯤꯒꯨꯝꯕꯁꯨ ꯑꯌꯥꯕ ꯄꯤꯔꯕꯅꯤ ꯍꯥꯌꯅ ꯏꯔꯔꯣꯏ, ꯅꯪꯅ ꯈꯅꯕ ꯄꯥꯟꯗꯝꯁꯤꯡꯁꯨ ꯅꯠꯇꯦ।",
    otpTitle: "ꯆꯦꯛ ꯇꯧꯕꯒꯤ ꯀꯣꯗ ꯆꯪꯁꯤꯜꯂꯨ",
    otpDescription:
      "ꯊꯥꯔꯛꯂꯕ ꯀꯣꯗ ꯑꯗꯨ ꯄꯥꯕꯅꯤ ꯍꯥꯌꯅ ꯒ꯭ꯔꯥꯍꯀꯗ ꯍꯥꯌꯌꯨ। ꯆꯨꯝꯃꯤ ꯍꯥꯌꯗ꯭ꯔꯤꯉꯩ ꯅꯪꯒꯤ ꯈꯅꯕꯁꯤꯡ ꯂꯣꯛ ꯇꯧꯔꯒꯅꯤ।",
    otpSubmit: "ꯀꯣꯗ ꯆꯨꯝꯃꯤ ꯍꯥꯌꯌꯨ",
    otpVerifying: "ꯆꯦꯛ ꯇꯧꯔꯤ...",
    otpFailed: "ꯀꯣꯗ ꯑꯗꯨ ꯆꯦꯛ ꯇꯧꯕ ꯉꯃꯗꯦ।",
    productPoliciesLabel: "ꯑꯔꯣꯠꯄꯒꯤ ꯄꯥꯟꯗꯝꯁꯤꯡ:",
    hintNothingChosen: "ꯆꯨꯝꯃꯤ ꯍꯥꯌꯅꯕ ꯌꯥꯝꯅ ꯌꯥꯝꯅ ꯄꯥꯟꯗꯝ ꯑꯃ ꯈꯜꯂꯨ।",
    hintNothingEngaged:
      "ꯅꯪꯅ ꯑꯌꯥꯕ ꯄꯤꯔꯤꯕ ꯄ꯭ꯔꯣꯗꯛꯠ ꯑꯗꯨꯒꯤ ꯄꯥꯟꯗꯝ ꯈꯜꯂꯨ ꯅꯠꯔꯒ ꯍꯣꯡꯗꯣꯛꯂꯨ।",
    hintRequiredOutstanding: "ꯆꯨꯝꯃꯤ ꯍꯥꯌꯅꯕ ꯗꯔꯀꯥꯔ ꯑꯣꯏꯕ ꯄꯥꯟꯗꯝꯁꯤꯡ ꯌꯥꯕꯤꯌꯨ।",
  },
  sat: {
    yes: "ᱦᱚᱭ",
    no: "ᱵᱟᱝ",
    mixed: "ᱠᱚᱴᱮᱫ",
    savedAnswer: "ᱥᱟᱸᱪᱟᱣ ᱛᱮᱞᱟ ᱛᱮᱞᱟ: {answer}",
    confirmAcceptAllTitle: "ᱡᱚᱛᱚ ᱩᱫᱫᱮᱥᱭ ᱦᱟᱛᱟᱣ ᱢᱮ?",
    confirmAcceptAllDetail:
      "ᱱᱳᱶᱟ ᱛᱮ ᱱᱚᱶᱟ ᱠᱷᱚᱵᱚᱨ ᱨᱮᱭᱟᱜ ᱡᱚᱛᱚ ᱩᱫᱫᱮᱥᱭ ᱨᱮ ᱨᱟᱡᱤ ᱮᱢᱚᱜᱼᱟ, ᱟᱢ ᱵᱟᱝ ᱵᱟᱪᱷᱟᱣ ᱟᱠᱟᱱ ᱠᱳ ᱦᱚᱸ।",
    confirmAcceptSelectedTitle: "ᱟᱢᱟᱜ ᱵᱟᱪᱷᱟᱣ ᱠᱚ ᱛᱷᱤᱠ ᱢᱮ?",
    confirmAcceptSelectedDetail:
      "ᱠᱷᱟᱹᱞᱤ ᱟᱢ ᱵᱟᱪᱷᱟᱣ ᱟᱠᱟᱱ ᱩᱫᱫᱮᱥᱭ ᱠᱚ ᱨᱟᱡᱤ ᱞᱮᱠᱟ ᱚᱞ ᱦᱩᱭᱩᱜᱼᱟ। ᱮᱴᱟᱜ ᱠᱚ ᱵᱟᱝ ᱨᱟᱡᱤ ᱞᱮᱠᱟ ᱚᱞ ᱦᱩᱭᱩᱜᱼᱟ।",
    confirmDeclineTitle: "ᱱᱚᱶᱟ ᱠᱷᱚᱵᱚᱨ ᱵᱟᱹᱜᱤ ᱢᱮ?",
    confirmDeclineDetail:
      "ᱡᱟᱦᱟᱸ ᱦᱚᱸ ᱨᱟᱡᱤ ᱞᱮᱠᱟ ᱵᱟᱝ ᱚᱞ ᱦᱩᱭᱩᱜᱼᱟ, ᱟᱢ ᱵᱟᱪᱷᱟᱣ ᱟᱠᱟᱱ ᱩᱫᱫᱮᱥᱭ ᱠᱚ ᱦᱚᱸ ᱵᱟᱝ।",
    otpTitle: "ᱡᱟᱸᱪ ᱠᱳᱰ ᱟᱫᱮᱨ ᱢᱮ",
    otpDescription:
      "ᱠᱩᱞ ᱟᱠᱟᱱ ᱠᱳᱰ ᱯᱟᱲᱦᱟᱣ ᱞᱟᱹᱜᱤᱫ ᱜᱟᱦᱟᱠ ᱠᱚ ᱢᱮᱛᱟᱣ ᱢᱮ। ᱛᱷᱤᱠ ᱵᱟᱝ ᱦᱩᱭ ᱦᱟᱹᱵᱤᱡ ᱟᱢᱟᱜ ᱵᱟᱪᱷᱟᱣ ᱠᱚ ᱞᱚᱠ ᱛᱟᱦᱮᱸᱱᱟ।",
    otpSubmit: "ᱠᱳᱰ ᱛᱷᱤᱠ ᱢᱮ",
    otpVerifying: "ᱡᱟᱸᱪ ᱠᱟᱱᱟ...",
    otpFailed: "ᱚᱱᱟ ᱠᱳᱰ ᱡᱟᱸᱪ ᱵᱟᱝ ᱦᱩᱭ ᱠᱮᱫᱟ।",
    productPoliciesLabel: "ᱱᱤᱡᱮᱨᱟᱜ ᱱᱤᱛᱤ ᱠᱚ:",
    hintNothingChosen: "ᱛᱷᱤᱠ ᱞᱟᱹᱜᱤᱫ ᱠᱚᱢ ᱛᱮ ᱠᱚᱢ ᱢᱤᱫ ᱩᱫᱫᱮᱥᱭ ᱵᱟᱪᱷᱟᱣ ᱢᱮ।",
    hintNothingEngaged:
      "ᱟᱢ ᱨᱟᱡᱤ ᱮᱢ ᱠᱟᱱ ᱯᱚᱱᱚᱛ ᱨᱮᱭᱟᱜ ᱩᱫᱫᱮᱥᱭ ᱵᱟᱪᱷᱟᱣ ᱢᱮ ᱟᱨ ᱵᱟᱝ ᱵᱚᱫᱚᱞ ᱢᱮ।",
    hintRequiredOutstanding: "ᱛᱷᱤᱠ ᱞᱟᱹᱜᱤᱫ ᱡᱟᱹᱨᱩᱨᱤ ᱩᱫᱫᱮᱥᱭ ᱠᱚ ᱦᱟᱛᱟᱣ ᱢᱮ।",
  },
  sd: {
    yes: "ها",
    no: "نه",
    mixed: "جزوي",
    savedAnswer: "محفوظ جواب: {answer}",
    confirmAcceptAllTitle: "سڀ مقصد قبول ڪجن؟",
    confirmAcceptAllDetail:
      "هن سان هن نوٽيس جي سڀني مقصدن تي رضامندي ڏني ويندي، انهن سميت جيڪي توهان نه چونڊيا.",
    confirmAcceptSelectedTitle: "پنهنجي چونڊ جي تصديق ڪجي؟",
    confirmAcceptSelectedDetail:
      "صرف توهان جا چونڊيل مقصد راضي طور درج ٿيندا. باقي غير راضي طور درج ٿيندا.",
    confirmDeclineTitle: "هي نوٽيس رد ڪجي؟",
    confirmDeclineDetail:
      "ڪجهه به راضي طور درج نه ٿيندو، توهان جا چونڊيل مقصد به نه.",
    otpTitle: "تصديقي ڪوڊ داخل ڪريو",
    otpDescription:
      "گراهڪ کي موڪليل ڪوڊ پڙهڻ لاءِ چئو. تصديق ٿيڻ تائين توهان جي چونڊ بند رهندي.",
    otpSubmit: "ڪوڊ جي تصديق ڪريو",
    otpVerifying: "تصديق ٿي رهي آهي...",
    otpFailed: "اهو ڪوڊ تصديق نه ٿي سگهيو.",
    productPoliciesLabel: "رازداري پاليسيون:",
    hintNothingChosen: "تصديق لاءِ گهٽ ۾ گهٽ هڪ مقصد چونڊيو.",
    hintNothingEngaged:
      "جنهن پراڊڪٽ لاءِ توهان رضامندي ڏئي رهيا آهيو، ان جو مقصد چونڊيو يا تبديل ڪريو.",
    hintRequiredOutstanding: "تصديق لاءِ گهربل مقصد قبول ڪريو.",
  },
  ks: {
    yes: "آہن",
    no: "نہ",
    mixed: "جُزوی",
    savedAnswer: "محفوظ جواب: {answer}",
    confirmAcceptAllTitle: "سٲری مقصد قبول کریو؟",
    confirmAcceptAllDetail:
      "یَمہ سان چھ اَمہ اطلاعہ ہٕنٛدین سٲری مقصدن پؠٹھ رضامندی دِیہ یوان، تِم تہٕ یَم توہہِ چھُ نہٕ ژارمُت۔",
    confirmAcceptSelectedTitle: "پننہِ ژارِ ہٕنٛز تصدیق کریو؟",
    confirmAcceptSelectedDetail:
      "صرف توہنٛدؠ ژارمٕتؠ مقصد ییہ راضی گۄڈنؠ درج کرنہٕ۔ باقی ییہ ناراضی گۄڈنؠ درج کرنہٕ۔",
    confirmDeclineTitle: "یہ اطلاع ردٕ کریو؟",
    confirmDeclineDetail:
      "کینٛہہ تہِ ییہ نہٕ راضی گۄڈنؠ درج کرنہٕ، توہنٛدؠ ژارمٕتؠ مقصد تہِ نہٕ۔",
    otpTitle: "تصدیقی کوڈ دِیو",
    otpDescription:
      "گاہکس ونیو زِ سۄ کوڈ پریو یُس بیجنہٕ آو۔ تصدیق گژھنہٕ تام آسِ توہنٛز ژار بند۔",
    otpSubmit: "کوڈ ہٕنٛز تصدیق کریو",
    otpVerifying: "تصدیق چھِ گژھان...",
    otpFailed: "سۄ کوڈ ہیوک نہٕ تصدیق گژھتھ۔",
    productPoliciesLabel: "رازداری پالیسی:",
    hintNothingChosen: "تصدیقہٕ خٲطرٕ کم از کم اکھ مقصد ژاریو۔",
    hintNothingEngaged:
      "یَمہ پراڈکٹس خٲطرٕ توہہِ چھِو رضامندی دِوان، تَمہ ہُنٛد مقصد ژاریو یا بدلاو۔",
    hintRequiredOutstanding: "تصدیقہٕ خٲطرٕ ضروری مقصد قبول کریو۔",
  },
};
